import { StyledModal } from '@app/components/modal/Modal';
import type { ModalProps } from 'antd';
import SaveFlowForm from '../forms/SaveFlowForm';
import FlowOverview from '../FlowOverview';

type SaveFlowModalProps = ModalProps & {
    onCancel: () => void;
    data: {
        title: string;
        onOkBtnTxt: 'Export' | 'Save';
        initialValues: { name: string };
        onOk: (name: string) => void;
    };
};

const SaveFlowModal = ({ data, onCancel, ...props }: SaveFlowModalProps) => {
    const { initialValues, onOk, onOkBtnTxt, title } = data;
    return (
        <StyledModal
            rootClassName="save-flow-modal"
            title={title}
            mask={{ closable: false }}
            footer={
                <SaveFlowForm
                    saveBtnText={onOkBtnTxt}
                    onCancel={onCancel}
                    onSave={onOk}
                    initialValues={initialValues}
                />
            }
            onCancel={onCancel}
            {...props}>
            <FlowOverview />
        </StyledModal>
    );
};

export default SaveFlowModal;
